import React from 'react';
import { PLUGIN_TOOLBAR_BUTTON_ID, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { FILE_UPLOAD_TYPE } from './types.js';
import { getVisibleOnlyOnDesktopResolver, Uploader } from 'wix-rich-content-plugin-commons';
import { SizePanel, NodeSizeButton, AlignmentPanel, NodeAlignmentButton } from 'wix-rich-content-toolbars-ui';
import { FILE_BUTTONS } from './consts.js';
import 'ricos-types';

const getToolbarButtons = (config, services, filePluginService) => {
  const {
    context: { isMobile }
  } = services;
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      modal: {
        Component: decorateComponentWithProps(SizePanel, {
          options: ["SMALL", "CONTENT"]
        }),
        id: FILE_BUTTONS.size
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeSizeButton, { id: FILE_BUTTONS.size, toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: FILE_BUTTONS.alignment
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: FILE_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      tooltip: "FileUploadReplaceButton_tooltip",
      command: ({ attributes: { selectedNode } }) => {
        const { updateService, uploadService } = services;
        if (config.handleFileSelection) {
          config.handleFileSelection(({ data }) => {
            const file = Array.isArray(data) ? data[0] : data;
            updateService.updatePluginData(
              { data: file },
              selectedNode.attrs.id,
              FILE_UPLOAD_TYPE,
              filePluginService
            );
          });
        } else {
          const { accept = "image/*", onFileSelected } = config;
          uploadService.selectFiles(
            accept,
            false,
            (files) => uploadService.uploadFile(
              files[0],
              selectedNode.attrs.id,
              new Uploader(onFileSelected),
              FILE_UPLOAD_TYPE,
              filePluginService
            )
          );
        }
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};

export { getToolbarButtons };
//# sourceMappingURL=getToolbarButtons.js.map
